import React from 'react'
import styled from 'styled-components'
import Logomark from '../layout/logomark.component'
import { BLUE } from '../../styles/colors.style'

const StyledLogo = styled.div`
	font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '75px')};
	margin-left: -20px;
	display: flex;
	align-items: center;
	justify-content: center;

	.name {
		font-family: 'MoskLight300';
		color: ${BLUE};
		margin-left: -22px;
		letter-spacing: -0.5px;
	}

	.points {
		font-family: 'GothamMedium-Italic';
		font-style: italic;
		letter-spacing: -2px;
	}

	.logo {
		margin-top: 5px;
		margin-right: 1.5px;
		z-index: 1;
		transform: ${({ fontSize }) => {
			if (fontSize > 14 && fontSize < 28) {
				return 'scale(0.2)'
			} else if (fontSize >= 28 && fontSize < 40) {
				return 'scale(0.25)'
			} else if (fontSize >= 40 && fontSize < 54) {
				return 'scale(0.3)'
			} else {
				return 'scale(0.35)'
			}
		}};
	}
`

const BaseLogo = ({ children, fontSize }) => (
	<StyledLogo fontSize={fontSize}>
		<Logomark />
		{children}
	</StyledLogo>
)

export default BaseLogo
